import {
  CONVERSATION_FACTS_MEASURES,
  DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_ROUTING_MEASURES,
  DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES,
  ROUTING_MEASURES,
  ROUTING_SANKEY_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for the routed chats teammate performance export.
 */
export const RoutedChatTeammatesBaseExportQuery: CubeQuery = {
  name: 'RoutedChatTeammatesExport',
  queryName: 'RoutedChatTeammatesExport',
  query: {
    dimensions: [
      DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS.DISPLAY_NAME,
    ],
    measures: [
      ROUTING_MEASURES.ROUTING_COUNT,
      ROUTING_SANKEY_MEASURES.TEAMMATE_ROUTED_IN_TO_MISSED,
      DRIFT_CHAT_CONVERSATION_ROUTING_MEASURES.AVERAGE_TIME_TO_FIRST_ROUTED_USER_RESPONSE,
      DRIFT_CHAT_CONVERSATION_ROUTING_MEASURES.COUNT_CONVOS_WITH_UNRESPONSIVE_FALLBACK_EVENTS,
      CONVERSATION_FACTS_MEASURES.MEDIAN_DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_SECONDS,
      CONVERSATION_FACTS_MEASURES.MEETINGS_BOOKED_COUNT,
      DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_AVERAGE,
      DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_COUNT,
    ],
    order: [[ROUTING_MEASURES.ROUTING_COUNT, 'desc']],
    filters: [
      {
        member: DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS.USER_ID,
        operator: 'set',
      },
    ],
  },
}
